import { render, staticRenderFns } from "./Masters2026.vue?vue&type=template&id=11b65bd6&scoped=true"
import script from "./Masters2026.vue?vue&type=script&lang=js"
export * from "./Masters2026.vue?vue&type=script&lang=js"
import style0 from "./Masters2026.vue?vue&type=style&index=0&id=11b65bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b65bd6",
  null
  
)

export default component.exports